// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"9649c1f3","354":"25d57265"}[chunkId] + ".chunk.js";
};